import React, { useState, useEffect } from "react";
import axios from 'axios';
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  Alert,
  Spinner,
  Progress,
} from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const FormAddVoices = () => {
  document.title = "Voices | Uma Classes";

  const [formData, setFormData] = useState({
    name: "",
    categoryId: "", // New field for category selection
    voiceFile: null, // New field for file upload
    title: "", // New field for title
  });

  const [categories, setCategories] = useState([]); // State for categories
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
  useEffect(() => {
    const token = localStorage.getItem('token');
    const fetchCategories = async () => {
      try {
        const response = await axios.get('https://uma.aasmo.in/api/admin/getall-category', {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          
        });
        setCategories(response); // Assuming the API returns an array of categories
        setLoading(false); // Set loading to false once data is fetched
      } catch (error) {
        console.error("Error fetching categories:", error);
        setLoading(false); // Ensure loading is set to false even on error
      }
    };

    fetchCategories();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value, // Handle file upload
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const formDataToSubmit = new FormData(); // Create a FormData object

      formDataToSubmit.append('title', formData.title); // Add title to FormData
      formDataToSubmit.append('categoryId', formData.categoryId);
      formDataToSubmit.append('voice', formData.voiceFile);
      setIsUploading(true);
      await axios.post('https://uma.aasmo.in/api/admin/add-voice', formDataToSubmit, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data", // Change to multipart/form-data for file uploads
        },
        onUploadProgress: (progressEvent) => {
          const progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(progress);
      },
      });
      setIsUploading(false);
      setSuccessMessage("Voice added successfully");
      setErrorMessage("");
      setFormData({ title: "", categoryId: "", voiceFile: null ,})
      setUploadProgress(0); 
    } catch (error) {
      console.error("Error adding Voice:", error);
      setIsUploading(false);
      setSuccessMessage("");
      setErrorMessage(error.response?.data?.message || "Error adding Voice");
    }
  };

  if (loading) {
    return <div>Loading categories...</div>; // Optional loading message
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Voices" breadcrumbItem="Add Voice" />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit}>

                    {/* Title field */}
                    <Row className="mb-3">
                      <label htmlFor="title" className="col-md-2 col-form-label">
                        Title
                      </label>
                      <div className="col-md-12">
                        <input
                          className="form-control"
                          type="text"
                          id="title"
                          name="title"
                          value={formData.title}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </Row>

                    {/* Category selection */}
                    <Row className="mb-3">
                      <label htmlFor="categoryId" className="col-md-2 col-form-label">
                        Select Category
                      </label>
                      <div className="col-md-12">
                        <select
                          id="categoryId"
                          name="categoryId"
                          className="form-control"
                          value={formData.categoryId}
                          onChange={handleChange}
                        >
                          <option value="">Select a category</option>
                          {categories.map(category => (
                            <option key={category._id} value={category._id}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Row>

                    {/* Voice file upload */}
                    <Row className="mb-3">
                      <label htmlFor="voiceFile" className="col-md-2 col-form-label">
                        Upload Voice
                      </label>
                      <div className="col-md-12">
                        <input
                          className="form-control"
                          type="file"
                          id="voiceFile"
                          name="voiceFile"
                          accept="audio/*" // Accept audio file types
                          onChange={handleChange}
                        />
                      </div>
                    </Row>
                    {/* Progress Bar */}
                    {isUploading && (
                      <Row className="mb-3">
                        <div className="col-md-12">
                          <Progress value={uploadProgress}>
                            {uploadProgress}%
                          </Progress>
                        </div>
                      </Row>
                    )}

                     {/* Loading Spinner */}
                     {isUploading && (
                                            <div className="text-center my-3">
                                                <Spinner color="primary" /> Uploading Voice...
                                            </div>
                                        )}
                    {/* Success and Error messages */}
                    {successMessage && <Alert color="success">{successMessage}</Alert>}
                    {errorMessage && <Alert color="danger">{errorMessage}</Alert>}

                    <button type="submit" className="btn btn-primary">Add</button>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FormAddVoices;
